import { useCallback, useEffect, useState } from 'react';
import { api } from './api';
import type { TokenBalance } from '../types';

export function useBalance(): { balance: TokenBalance | null; refresh: () => void } {
  const [balance, setBalance] = useState<TokenBalance | null>(null);

  const refresh = useCallback(() => {
    api.account.getBalance().then(setBalance).catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { balance, refresh };
}
